export default __webpack_public_path__ + "static/media/apartment.a76a507d.svg";